export function isSelected(value: { id: string | number }) {
  return (
    value &&
    value.id !== undefined &&
    value.id !== null &&
    value.id !== '' &&
    value.id !== 0
  );
}
